// sections: megamenu (1/2/3/4/5/6)
class MegaMenu extends HTMLElement {
  constructor(){
    super();

    var self = this;
    self.sectionId = 'shopify-section-' + this.dataset.sectionId;
    this.sectionActive = false;
    this.url = this.dataset.url || '';

    self.link = document.querySelector('.menu-section .header__menu a.header__link[href="' + self.url + '"]');
    if(self.link) {
      self.container = self.link.closest('.flex__item');
      this.setMegamenu(); 
    }

    document.addEventListener('shopify:section:load', function(e) {
      self.link = document.querySelector('.menu-section .header__menu a.header__link[href="' + self.url + '"]');
      self.setMegamenu();

      self.container.querySelectorAll('img, svg').forEach((image) => {
        image.classList.add('visible')
      })

      self.link = document.querySelector('.menu-section .header__menu a.header__link[href="' + self.url + '"]');
      if(self.closest('#' + e.target.id) && self.link) {
        self.container = self.link.closest('.flex__item');
        if(!self.container) { return; }
        self.container.classList.add('megamenu_active');
      } else if(self.link !== "undefined") {
        self.container = self.link.closest('.flex__item');
        self.container.classList.remove('megamenu_active');
      }
    });

    document.addEventListener('shopify:section:select', function(e) {
      self.link = document.querySelector('.menu-section .header__menu a.header__link[href="' + self.url + '"]');
      self.sectionActive = true;
      if(self.sectionId == e.target.id && self.link){
        self.container = self.link.closest('.flex__item');
        self.container.classList.add('megamenu_active');
      } else if (self.link){
        self.sectionActive = false;
        self.container = self.link.closest('.flex__item');
        self.container.classList.remove('megamenu_active');
      } else {
        self.sectionActive = false;
      }
    });

    document.addEventListener('shopify:block:select', function(e) {
      self.link = document.querySelector('.menu-section .header__menu a.header__link[href="' + self.url + '"]');
      self.sectionActive = true;
      if(e.target.id && document.querySelector('#' + self.sectionId + ' #' + e.target.id) && self.link) {
        self.container = self.link.closest('.flex__item');
        self.container.classList.add('megamenu_active');
      } else if (self.link){
        self.sectionActive = false;
        self.container = self.link.closest('.flex__item');
        self.container.classList.remove('megamenu_active');
      } else {
        self.sectionActive = false;
      }
    });

    document.addEventListener('shopify:section:deselect', function(e) {
      self.link = document.querySelector('.menu-section .header__menu a.header__link[href="' + self.url + '"]');
      if(document.querySelector('#' + self.sectionId) && self.link && self.link.closest('.flex__item').classList.contains('megamenu_active')) {
        self.sectionActive = false;
        self.container = self.link.closest('.flex__item');
        self.container.classList.remove('megamenu_active');
      }
    })
  }

  setMegamenu(){
    this.container = this.link.closest('.flex__item');
    this.container.querySelector('.section-container') && this.container.querySelector('.section-container').remove();
    this.container.innerHTML += this.innerHTML;
    if(!this.container.querySelector('.header__link span svg'))
      this.container.querySelector('.header__link span').innerHTML += Shopify.theme_settings.arrowRight;
    this.container.classList.add('has-megamenu');
    if(this.container.querySelector('.header__menu-child'))
      this.container.querySelector('.header__menu-child').remove();

    this.linkCollapsing = this.container.querySelectorAll('link-collapsing a[db-click]');

    if(this.linkCollapsing.length > 0){
      this.linkCollapsing.forEach(link => link.addEventListener('click', function(e) {
        e.preventDefault();
      }));

      this.linkCollapsing.forEach(link => link.addEventListener('dblclick', function(e) {
        window.location.href = this.href;
      }));
    }
  }
}
customElements.define('mega-menu', MegaMenu);